var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarbageTruckHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29429",
    "data-name": "Group 29429",
    transform: "translate(-220.999 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(220.999 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29424",
    "data-name": "Group 29424",
    transform: "translate(-16.35 -1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50845",
    "data-name": "Path 50845",
    d: "M315.395,168.389l2.453-9.168h3.562a.336.336,0,0,1,.269.135l1.018,1.358,1.119,4.178v2.537Z",
    transform: "translate(-48.758 357.036)",
    fill: "#6eaa2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50846",
    "data-name": "Path 50846",
    d: "M316.356,159.221l-.961,9.168,2.453-.961v-8.207Z",
    transform: "translate(-48.758 357.036)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50847",
    "data-name": "Path 50847",
    d: "M373.968,195.4h-1.722a.336.336,0,0,1-.25-.111l-.346-.385a1.3,1.3,0,0,0-.965-.43h-2.35a.336.336,0,0,1-.336-.336v-2.58a.336.336,0,0,1,.336-.336h4.513l1.052,1.4a.336.336,0,0,1,.067.2Z",
    transform: "translate(-98.908 326.528)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50848",
    "data-name": "Path 50848",
    d: "M360.966,285.016h-.334a.36.36,0,1,1,0-.721h.334a.36.36,0,0,1,0,.721Z",
    transform: "translate(-91.542 237.795)",
    fill: "#47840b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50838",
    "data-name": "Path 50838",
    d: "M19.33,111.534H29.1l.034.634.349.438v9.359l-5.223.961-1.492-1.788-6.748-.869-1.53-2.42v-2.589l4.032-2.667Z",
    transform: "translate(238.117 402.5)",
    fill: "#6eaa2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50839",
    "data-name": "Path 50839",
    d: "M1.6,115.179,4.927,113.1a.336.336,0,0,0,.142-.182l.447-1.39H4.772l-1.144,1.39a.336.336,0,0,1-.142.182L.158,115.179a.336.336,0,0,0-.158.285v1.964a.337.337,0,0,0,.043.165l1.449,2.583.7.622.738-.622-1.449-2.583a.336.336,0,0,1-.043-.165v-1.964a.336.336,0,0,1,.158-.285Zm7.354,5,.772,2.508,2.161-.72L10.5,120.3a.336.336,0,0,0-.258-.121H8.953Z",
    transform: "translate(251.93 402.501)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50840",
    "data-name": "Path 50840",
    d: "M42.593,150.742l.488.87,1.7-5.786-.242-.461-.68,1.036Z",
    transform: "translate(211.323 370.246)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50841",
    "data-name": "Path 50841",
    d: "M35.28,111.533h-.452a.336.336,0,0,0-.32.233l-.372,1.156A.337.337,0,0,1,34.1,113l-.335,1.146.922-.575.581-1.973A.378.378,0,0,0,35.28,111.533ZM32,120.176l.3.494.465-.494.215-.819-.488-.87Z",
    transform: "translate(221.422 402.501)",
    fill: "#47840b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50842",
    "data-name": "Path 50842",
    d: "M108.744,141.87h-1.695a.028.028,0,0,1-.025-.042l.685-1.268.06.165a.36.36,0,1,0,.678-.245l-.333-.921a.361.361,0,0,0-.429-.226l-.995.253a.36.36,0,1,0,.178.7l.2-.051-.677,1.253a.749.749,0,0,0,.659,1.1h1.695a.36.36,0,1,0,0-.721Zm3.058-1.99a.36.36,0,1,0-.624.36l.9,1.552a.025.025,0,0,1,0,.028.025.025,0,0,1-.021.014H110.6l.126-.15a.36.36,0,1,0-.551-.464l-.63.747a.363.363,0,0,0,.018.488l.715.734a.36.36,0,0,0,.516-.5l-.127-.131h1.407a.749.749,0,0,0,.627-1.123Zm-2.328-2.487.756,1.228-.173-.031a.36.36,0,0,0-.127.709l.964.172a.362.362,0,0,0,.411-.26l.278-.986a.36.36,0,1,0-.694-.2l-.056.2-.746-1.212a.749.749,0,0,0-1.286.018l-.86,1.49a.36.36,0,1,0,.624.36l.86-1.49a.025.025,0,0,1,.024-.014A.028.028,0,0,1,109.474,137.393Z",
    transform: "translate(150.588 378.546)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50849",
    "data-name": "Path 50849",
    d: "M252.362,111.87v.736l-3.392,9.51a.361.361,0,0,1-.339.239.355.355,0,0,1-.121-.021.36.36,0,0,1-.218-.46l3.687-10.339h.047a.336.336,0,0,1,.336.336Z",
    transform: "translate(15.236 402.5)",
    fill: "#58931f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50843",
    "data-name": "Path 50843",
    d: "M28.364,300.157H6.265l-1.139-.367L5.06,299a1.311,1.311,0,0,1,.073-.448l2.624-1.678h6.02l1.492,1.788H28.364A.336.336,0,0,1,28.7,299v.82a.336.336,0,0,1-.336.336Z",
    transform: "translate(247.105 225.8)",
    fill: "#edba48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50844",
    "data-name": "Path 50844",
    d: "M2.933,296.877H1.492L.078,298.572a.336.336,0,0,0-.078.215v1.034a.336.336,0,0,0,.336.336h1.1v-1.37a.336.336,0,0,1,.078-.216Z",
    transform: "translate(251.93 225.8)",
    fill: "#e2a02b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 2.386,
    cy: 2.386,
    rx: 2.386,
    ry: 2.386,
    transform: "translate(269.252 522.677)",
    fill: "#465679"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    cx: 0.924,
    cy: 0.925,
    rx: 0.924,
    ry: 0.925,
    transform: "translate(270.714 524.139)",
    fill: "#39395f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 2.386,
    cy: 2.386,
    rx: 2.386,
    ry: 2.386,
    transform: "translate(254.767 522.734)",
    fill: "#465679"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 0.924,
    cy: 0.925,
    rx: 0.924,
    ry: 0.925,
    transform: "translate(256.229 524.196)",
    fill: "#39395f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageTruckHighlighted);
export default __webpack_public_path__ + "static/media/garbageTruckHighlighted.85588477a29ec640026de950663cda62.svg";
export { ForwardRef as ReactComponent };